import { Component } from "react";

import BulkStatusSelector from "./BulkStatusSelector";

import { RegionSetQualifier } from "@app/region-sets";
import { CountyProjectContextProps } from "../CountyProjectContext";

interface ChangeStatusLinkOnlyProps {
  countyPerspectiveOnlyItems: boolean;
  regions: RegionSetQualifier[];
}

type ChangeStatusLinkProps = CountyProjectContextProps & ChangeStatusLinkOnlyProps;

class ChangeStatusLink extends Component<ChangeStatusLinkProps> {
  constructor(props: ChangeStatusLinkProps) {
    super(props);
  }

  public render() {
    if (this.props.countyPerspectiveOnlyItems) {
      return (
        <BulkStatusSelector regions={this.props.regions} {...this.props} />
      );
    } else {
      return null;
    }
  }
}

export { ChangeStatusLink, ChangeStatusLinkProps };
